export default __webpack_public_path__ + "static/media/pic8-1.256f2fc0.jpg";